import React, { useEffect, useState, useRef } from 'react';
import Axios from 'axios';
import {
	getCurrencySymbol,
	loadState,
	loadStateSession,
} from '../../../../FlyfishComponents/flyfishutils/utils';
import styled from 'styled-components';
import { LoaderGif } from '../../../../FlyfishComponents/flyfishIcons/icons';
import { FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material';
import Modal from '../../../../FlyfishComponents/Modal';
import Button from '../../../../FlyfishComponents/Button';
import EcomCarousel from '../../EcomTheme/EcomCartItem/EcomCarousel';
const MonacoModalContainer = styled.div`
	position: relative;
	& > .closeModalSVG {
		margin: 4px;
		cursor: pointer;
		position: absolute;
		right: 0;
		z-index: 1;
	}
	& > .ff-closeModalSVG-cnt {
		display: flex;
		justify-content: end;
		position: sticky;
		top: 8px;
		cursor: pointer;
		margin-right: 8px;
		margin-top: 8px;
		@media (max-width: 600px) {
			z-index: 9999999;
		}
	}
	& .product-addition-dialogue {
		& > .modal-container-bot {
			max-width: 423px;
			height: unset;
			display: flex;
			align-items: center;
			padding: 24px;

			& > .body1 {
				font-family: var(--fontFamily);
				font-size: 18px;
				text-align: center;
				display: flex;
				flex-direction: column;

				overflow: hidden;
				& > div.svg {
					display: flex;
					justify-content: center;
					margin-bottom: 20px;
				}
				& > div.title-holder {
					margin-bottom: 24px;
				}
				& > .custom-button {
					& > button {
						padding: 5px 12px;
						height: 40px;
						background-color: black;
						color: white;
						width: 100%;
						border-radius: inherit;
						font-size: 16px;
						font-family: var(--fontFamily);
					}
					&:last-child {
						margin-top: 12px;
						& > button {
							border: 1px solid #cbcbcb;
							background-color: #f5f5f5;
							& > .custom-button-body {
								color: black;
							}
							&:hover {
								border-radius: 0;
							}
						}
					}
				}
			}
		}
	}
`;
const ProductContainer = styled.div`
	background-color: #fff;
	padding: 24px 56px 24px 24px;
	width: 100%;
	font-family: var(--fontFamily);
	@media (max-width: 600px) {
		padding: 0px;
	}
	> div {
		&:nth-of-type(1) {
			display: flex;

			@media (max-width: 600px) {
				flex-direction: column;
			}
		}
		&:nth-of-type(2) {
			background-color: #f7f7f7;
			padding: 20px;
			margin-top: 25px;
			> div {
				&:nth-of-type(1) {
					font-weight: 500;
					@media (max-width: 600px) {
					}
				}
				&:nth-of-type(2) {
					margin-top: 7px;
					@media (max-width: 600px) {
					}
				}
			}
		}
	}
`;
const ProductImageDisplay = styled.div`
	margin-right: 30px;
	display: flex;
	flex-direction: row;
	width: 50%;
	height: fit-content;
	position: sticky;
	top: 24px;
	@media (max-width: 600px) {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.ff-selected-image {
	}
	> div {
		> img {
			width: 97%;
			height: 100%;
		}
	}

	> div {
		&:nth-of-type(2) {
			max-height: fit-content;
			margin-left: 25px;
			width: 100%;
			> img {
				object-fit: contain;
				height: auto;
				width: 100%;
				max-height: fit-content;
			}
		}
		&:nth-of-type(1) {
			@media (max-width: 600px) {
				margin-left: 30px;
				width: 100%;
			}
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			max-width: 300px;
			flex-direction: column;
			> div {
				display: flex;
				width: 48px;
				margin: 5px 1.2% 10px;
				justify-content: center;
				align-items: center;
				margin-top: 0px;

				> img {
					width: 100%;
					object-fit: contain;
					height: auto;
				}
			}
		}
	}
`;
const ProductDescription = styled.div`
	margin-left: 0px;
	width: 50%;
	font-family: var(--fontFamily);
	.ff-vendor {
		@media (max-width: 600px) {
			text-align: center;
		}
	}
	.ff-monaco-recommendation {
		padding: 12px;
		margin-bottom: 20px;
		background-color: #f7f7f7;
		padding-top: 15px;
		@media (max-width: 600px) {
			width: 90%;
		}
		&.mobile {
			margin-top: 35px;
			margin-bottom: 0px;
		}
		> div {
			&:nth-of-type(1) {
				font-weight: 500;
			}
			&:nth-of-type(2) {
				font-size: 14px !important;
				margin-top: 7px;
			}
		}
	}
	@media (max-width: 600px) {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-top: 20px;
		s > div {
			&:nth-of-type(1) {
				text-align: center;
			}
		}
	}

	& > .custom-button {
		margin-top: 20px;
		width: 100%;
		@media (max-width: 600px) {
			width: 90%;
		}
		& > .MuiButtonBase-root.MuiButton-root {
			width: 100%;
			height: 44px !important;
			background-color: #000 !important;
			text-transform: uppercase !important;
			font-family: var(--fontFamily);
			min-width: 300px !important;
			letter-spacing: 0.1em;
			border-radius: 0 !important;
			& > .button-loader {
				display: flex;
			}
		}
	}
	.ff-out-stock {
		background-color: transparent;
		color: var(--selectedColor);
		border: 1px solid var(--selectedColor);
		opacity: 0.5;
		cursor: not-allowed;
	}
	.ff-chatbot-h6 {
		text-transform: uppercase;
		margin-top: 3px;
		margin-bottom: 3px;
	}
	.ff-description {
		font-size: 14px;
		margin-top: 25px;
		line-height: 21px;
		@media (max-width: 600px) {
			width: 90%;
			margin-bottom: 23px;
		}
	}
`;
const ProductVariants = styled.div`
	> .choices {
		& > div {
			& > .title {
				margin-top: 16px;
				margin-bottom: 8px;
				@media (max-width: 600px) {
					text-align: center;
				}
			}
			& > .MuiFormGroup-root {
				display: flex;
				cursor: pointer;
				display: -webkit-box;

				& > label {
					margin-right: 8px;
					margin-bottom: 8px;
					margin-left: unset;
					&.active {
						background-color: var(--selectedColor);
						color: #fff;
					}
					padding: 4px 12px;
					text-transform: capitalize;
					border: solid 1px #b2b1b1;
					border: ${(props: any) =>
		`solid 1px ${props.colorScale && props.colorScale[8]}`};

					& > span:first-child {
						display: none;
					}
				}
			}
		}
	}
`;
const MonacoLoader = styled.div`
	height: 86vh;
	background-color: #fff;
	width: 100%;
`;
const ProductQuantity = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid #b2b1b1;
	width: fit-content;
	& > .ff-quantity-display {
		width: 30px;
		border: none;
		text-align: center;
	}
	& > .MuiFormControl-root {
		& > .MuiInputBase-root {
			& > fieldset {
				border: none;
			}
			& > input {
				padding: 0px;
			}
		}
	}
	& > .svg-holder {
		cursor: pointer;
		background-color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 28px;
		width: 30px;
	}
`;
type Props = {
	tenantId;
	token;
	secondAPI;
	data;
	createCart;
	closeModal;
	handleSelectedProduct;
	closeAPI;
	callOnce;
	setReasonData;
	reasonData;
	selectedTheme;
	conversationId;
};

const MonacoModal = ({
	tenantId,
	token,
	secondAPI,
	data,
	createCart,
	closeModal,
	handleSelectedProduct,
	closeAPI,
	callOnce,
	reasonData,
	setReasonData,
	selectedTheme,
	conversationId,
}: // botId,
	Props) => {
	const [productImage, setProductImage] = useState([]);
	const [selectedImageIndex, setSelectedImageIndex] = useState(0);
	const [selectedImage, setSelectedImage] = useState('');
	const [choices, setChoices] = useState([]);
	const [type, setType] = useState('');
	const [response, setResponse] = useState<any>(null);
	const [selectedVariant, setSelectedVariant] = useState<any>();
	const [price, setPrice] = useState<any>('');
	const [sku, setSku] = useState('');
	const [quantity, setQuantity] = useState(1);
	const [reason, setReason] = useState<any>(null);
	const [loader, setLoader] = useState(false);
	const [variantId, setVariantId] = useState('');
	const [inventory, setInventory] = useState(-1);
	const [taxable, setTaxable] = useState(false);
	const [selectedVariantIndex, setSelectedVariantIndex] = useState(0);
	const [selectedOptions, setSelectedOptions] = useState([]);
	const [productAdded, setProductAdded] = useState(false);
	const [zoomEnable, setZoomEnable] = useState(false);
	const [mobile, setMobile] = useState(false);
	const [productAddedLoader, setProductAddedLoader] = useState(false);
	const [productAdditionFailed, setProductAdditionFailed] = useState(false);

	useEffect(() => {
		if (window.innerWidth < 1000 || window.screen.width < 1000) {
			setMobile(true);
		} else {
			setMobile(false);
		}
		window.addEventListener(
			'resize',
			function (event) {
				if (window.innerWidth < 1000 || window.screen.width < 1000) {
					setMobile(true);
				} else {
					setMobile(false);
				}
			},
			true
		);
	});

	// useEffect(() => {
	// 	let reason =
	// 		reasonData &&
	// 		reasonData.data.metaData.products.filter((item) => {
	// 			return item.product_id == loadStateSession('FF-productID');
	// 		});
	// 	if (reasonData) setReason(reason);
	// }, [reasonData]);
	useEffect(() => {
		setLoader(true);
		// if (secondAPI === 'true' && callOnce === false) {
		// 	Axios.post(
		// 		window['BASE_URL'] + `/messages/product_details`,
		// 		{
		// 			id: data.productData.id,
		// 			message: data.productData.message,
		// 			botId: data.productData.botId,
		// 			version: 'prod',
		// 			country: loadStateSession('FS-countryCode'),
		// 			metaData: data.productData.metaData,
		// 		},
		// 		{
		// 			headers: {
		// 				'x-tenant-id': data.productData.tenantID,
		// 				Authorization: `Bearer ${data.productData.token}`,
		// 			},
		// 		}
		// 	).then((response) => {
		// 		let reason = response && closeAPI();
		// 		setReasonData(response);
		// 	});
		// }

		loadStateSession('FF-productID') &&
			Axios.get(
				`${window['BASE_URL']
				}/shop/${tenantId}/product?productId=${loadStateSession(
					'FF-productID'
				)}&country=${loadStateSession('FS-countryCode')}`,
				{
					headers: {
						'x-tenant-id': tenantId,
						Authorization: `Bearer ${token}`,
					},
				}
			).then((resp: any) => {
				let response = resp.data.response.data;
				setResponse(resp.data.response.data);
				setProductImage(response.images);
				setSelectedImage(response.images[0]);
				setChoices(response.choices);
				setLoader(false);
				setSelectedVariant(response.variants && response.variants[0]);
				setSelectedOptions(response.variants && response.variants[0].options);
				setLoader(false);
			});
	}, []);

	const findSelectedVariant = (selectedOptions) => {
		const selectedVariantIndex = response.variants.findIndex((variant) =>
			selectedOptions.every((selectedOption) =>
				variant.options.some(
					(variantOption) =>
						variantOption.type === selectedOption.type &&
						variantOption.value === selectedOption.value
				)
			)
		);

		const selectedVariant = response.variants[selectedVariantIndex];
		setSelectedVariantIndex(selectedVariantIndex);
		return selectedVariant;
	};

	const handleChange = (event, choiceIndex) => {
		const { value } = event.target;

		const updatedSelectedOptions = [...selectedOptions];
		updatedSelectedOptions[choiceIndex] = {
			type: choices[choiceIndex].type,
			value,
		};
		setSelectedOptions(updatedSelectedOptions);

		// Call a function to find the variant based on selectedOptions
		const selectedVariant = findSelectedVariant(updatedSelectedOptions);

		if (selectedVariant) {
			setSelectedVariant(selectedVariant);
			// if (quantity > selectedVariant.quantity) {
			// 	setQuantityError(true);
			// } else {
			// 	setQuantityError(false);
			// }
			// Perform actions with selected variant
		} else {
			console.log('Variant not found for selected options');
		}
	};

	const handleIncrement = () => {
		setQuantity(quantity + 1);
	};

	const handleDecrement = () => {
		if (quantity > 1) {
			setQuantity(quantity - 1);
		}
	};
	return (
		<MonacoModalContainer>
			<div className='ff-closeModalSVG-cnt'>
				<svg
					className='closeModalSVG'
					onClick={() => closeModal()}
					width='30'
					height='30'
					viewBox='0 0 30 30'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<g clip-path='url(#clip0_22059_1280)'>
						<path
							d='M24.971 4.28199C22.9254 2.23641 20.3191 0.843367 17.4818 0.279015C14.6444 -0.285337 11.7034 0.0043515 9.03074 1.11145C6.35802 2.21854 4.07362 4.09332 2.46641 6.49871C0.859191 8.9041 0.00134277 11.7321 0.00134277 14.625C0.00134277 17.5179 0.859191 20.3459 2.46641 22.7513C4.07362 25.1567 6.35802 27.0314 9.03074 28.1385C11.7034 29.2456 14.6444 29.5353 17.4818 28.971C20.3191 28.4066 22.9254 27.0136 24.971 24.968C27.713 22.2242 29.2533 18.504 29.2533 14.625C29.2533 10.746 27.713 7.02575 24.971 4.28199ZM24.106 24.103C22.2317 25.9762 19.844 27.2517 17.2449 27.7681C14.6458 28.2845 11.9519 28.0187 9.50382 27.0042C7.05574 25.9898 4.96341 24.2723 3.49135 22.0688C2.01928 19.8654 1.23358 17.2749 1.23358 14.625C1.23358 11.9751 2.01928 9.38461 3.49135 7.18117C4.96341 4.97772 7.05574 3.2602 9.50382 2.24576C11.9519 1.23131 14.6458 0.96549 17.2449 1.4819C19.844 1.9983 22.2317 3.27375 24.106 5.14699C26.6151 7.66319 28.0241 11.0716 28.0241 14.625C28.0241 18.1784 26.6151 21.5868 24.106 24.103Z'
							fill='black'
						/>
						<path
							d='M20.5481 7.875L14.6141 13.795L8.70805 7.903L7.87805 8.733L13.7841 14.625L7.87805 20.517L8.70805 21.347L14.6141 15.455L20.5481 21.375L21.3781 20.545L15.4441 14.625L21.3781 8.705L20.5481 7.875Z'
							fill='black'
						/>
					</g>
					<defs>
						<clipPath id='clip0_22059_1280'>
							<rect width='29.255' height='29.25' fill='white' />
						</clipPath>
					</defs>
				</svg>
			</div>
			{loader ? (
				<MonacoLoader>
					<div className='ff-loader-cnt'>
						<LoaderGif />
					</div>
				</MonacoLoader>
			) : (
				<ProductContainer>
					<div>
						{mobile ? (
							<EcomCarousel
								productImage={productImage}
								handleZoom={(image) => {
									setZoomEnable(true);
									setSelectedImage(image);
								}}
								showBacktoConv={false}
								showBack={true}
							/>
						) : (
							<ProductImageDisplay>
								<div>
									{productImage &&
										productImage.map((item, index) => {
											return (
												<div
													style={{
														border:
															selectedImageIndex == index
																? '1px solid var(--selectedColor)'
																: '1px solid transparent',
													}}
												>
													<img
														onClick={() => {
															setSelectedImageIndex(index);
															setSelectedImage(item);
														}}
														src={item}
													/>
												</div>
											);
										})}
								</div>
								<div>
									<img
										src={productImage && selectedImage}
										className='ff-selected-image'
									/>
								</div>
							</ProductImageDisplay>
						)}

						<ProductDescription>
							{!mobile &&
								reasonData.length > 0 ? (
								<div className='ff-monaco-recommendation'>
									<div className='ff-chatbot-body1'>{`Why do we recommend ${response &&
										response.title}?`}</div>
									<div className='ff-chatbot-body2 '>
										{reasonData}
									</div>
								</div>
							) : null}
							<div style={{ letterSpacing: '0.1em' }}>
								<div
									className='ff-chatbot-caption ff-vendor'
									style={{ textTransform: 'uppercase' }}
								>
									{response && response.vendor}
								</div>
								<div className='ff-chatbot-h6 '>
									{response && response.title}
								</div>
								{sku && <div className='ff-chatbot-caption'>SKU: {sku}</div>}
							</div>
							<div style={{ marginTop: '3px', letterSpacing: '0.1em' }}>
								<div className='ff-chatbot-body2 '>
									{getCurrencySymbol(
										selectedVariant && selectedVariant.currency
									)}
									{selectedVariant && selectedVariant.price}
								</div>
								{taxable && (
									<div
										className='ff-chatbot-caption tax'
										style={{ marginTop: '5px' }}
									>
										Tax included:{' '}
										<a
											target='_blank'
											href='https://www.apm.mc/policies/shipping-policy'
										>
											Shipping calculated
										</a>{' '}
										at checkout
									</div>
								)}
							</div>

							<div
								className='ff-chatbot-body2'
								style={{
									color: '#000',
									marginTop: '15px',
									marginBottom: '5px',
								}}
							>
								Quantity
							</div>
							<ProductQuantity>
								<div className='svg-holder' onClick={handleDecrement}>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='20'
										height='20'
										viewBox='0 0 20 20'
									>
										<path data-name='Path 5' d='M0 0h20v20H0z' fill='none' />
										<path
											data-name='Path 6'
											d='M16.667 12.667H5V11h11.667z'
											transform='translate(-.833 -1.833)'
											fill='var(--selectedColor)'
										/>
									</svg>
								</div>
								<input
									type='text'
									value={quantity}
									readOnly
									className='ff-quantity-display'
								/>
								{/* <TextField
									type='number'
									value={quantity}
									aria-readonly
									// onChange={(e) => setQuantity(Number(e.target.value))}
								/> */}

								<div className='svg-holder' onClick={handleIncrement}>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='20'
										height='20'
										viewBox='0 0 20 20'
									>
										<path data-name='Path 3' d='M0 0h20v20H0z' fill={'none'} />
										<path
											data-name='Path 4'
											d='M16.667 11.667h-5v5H10v-5H5V10h5V5h1.667v5h5z'
											transform='translate(-.833 -.833)'
											fill='var(--selectedColor)'
										/>
									</svg>
								</div>
							</ProductQuantity>
							{response && response.choices.length > 0 && (
								<ProductVariants>
									<div className='choices'>
										{choices.map((choice, choiceIndex) => (
											<>
												<div
													key={choice.type + choiceIndex}
													className={`group ${choiceIndex}`}
												>
													<div className='ff-chatbot-body2 title'>
														{choice.type}
													</div>
													<RadioGroup
														aria-label={choice.type}
														name={choice.type}
														value={
															(selectedOptions[choiceIndex] &&
																selectedOptions[choiceIndex].value) ||
															''
														}
														onChange={(event) =>
															handleChange(event, choiceIndex)
														}
													>
														{choice.values.map((value, valueIndex) => {
															const isSelected =
																selectedOptions[choiceIndex] &&
																selectedOptions[choiceIndex].value === value;
															//let value1 =value
															// choice.type.toLowerCase() === 'size'
															// 	? value.slice(0, 1)
															//value;
															return (
																<FormControlLabel
																	className={isSelected ? 'active' : ''}
																	key={valueIndex}
																	value={value}
																	control={<Radio />}
																	label={value}
																/>
															);
														})}
													</RadioGroup>
												</div>
											</>
										))}
									</div>
								</ProductVariants>
							)}

							{/* {
						inventory === 0?
						<button className='ff-action-btn ff-out-stock'>Out of Stock</button>: */}

							<Button
								loading={productAddedLoader}
								onClick={() => {
									if (loadState('ff_shopify_cook') !== undefined) {
										setProductAddedLoader(true);
										let payload: any = {
											conversationId: conversationId,
											productId: loadStateSession('FF-productID'),
											quantity: quantity,
											variantId: selectedVariant && selectedVariant.id,
											shopifyToken: loadState('ff_shopify_cook').replace(
												',',
												';'
											),
										};
										fetch(window['BASE_URL'] + '/shop/product/cart', {
											method: 'POST',
											headers: {
												'Content-Type': 'application/json',
												'x-tenant-id': tenantId,
												Authorization: `Bearer ${token}`,
											},
											body: JSON.stringify(payload),
										})
											.then((data) => data.json())
											.then((response) => {
												if (response.status.toLowerCase() === 'success') {
													setProductAddedLoader(false);
													setProductAdded(true);
												} else {
													setProductAddedLoader(false);
													setProductAdded(false);
													setProductAdditionFailed(true);
												}
											})
											.catch((err) => {
												setProductAddedLoader(false);
												setProductAdded(false);
												setProductAdditionFailed(true);
											});
									}
								}}
							>
								Add to Bag
							</Button>

							{mobile &&
								reason &&
								reason.length &&
								reason[0].reason_query.length > 0 ? (
								<div
									className={`ff-monaco-recommendation ${mobile ? 'mobile' : ''
										}`}
								>
									<div className='ff-chatbot-body1'>
										{reason && reason.length && reason[0].reason_query}
									</div>
									<div className='ff-chatbot-body2 '>
										{reason && reason.length && reason[0].reason}
									</div>
								</div>
							) : null}

							<div
								dangerouslySetInnerHTML={{
									__html: response && response.descriptionHtml,
								}}
								className='ff-description'
							></div>
						</ProductDescription>
					</div>
				</ProductContainer>
			)}
			{productAdded && (
				<Modal
					className='product-addition-dialogue'
					footerNotReq={true}
					onClose={() => setProductAdded(false)}
					actionButtons={<></>}
				>
					<>
						<div className='svg'>
							{productAdditionFailed ? (
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='49'
									height='48'
									viewBox='0 0 49 48'
									fill='none'
								>
									<g id='error'>
										<mask
											id='mask0_44_13317'
											style={{ maskType: 'alpha' }}
											maskUnits='userSpaceOnUse'
											x='0'
											y='0'
											width='49'
											height='48'
										>
											<rect
												id='Bounding box'
												x='0.5'
												width='48'
												height='48'
												fill='#D9D9D9'
											/>
										</mask>
										<g mask='url(#mask0_44_13317)'>
											<path
												id='error_2'
												d='M24.5 32.923C24.8487 32.923 25.141 32.805 25.377 32.569C25.613 32.3333 25.731 32.0412 25.731 31.6925C25.731 31.3435 25.613 31.0512 25.377 30.8155C25.141 30.5795 24.8487 30.4615 24.5 30.4615C24.1513 30.4615 23.859 30.5795 23.623 30.8155C23.387 31.0512 23.269 31.3435 23.269 31.6925C23.269 32.0412 23.387 32.3333 23.623 32.569C23.859 32.805 24.1513 32.923 24.5 32.923ZM23.5 26.3075H25.5V14.3075H23.5V26.3075ZM24.5065 42C22.0175 42 19.6773 41.5277 17.486 40.583C15.295 39.6383 13.389 38.3563 11.768 36.737C10.147 35.1177 8.86383 33.2133 7.9185 31.024C6.97283 28.835 6.5 26.4958 6.5 24.0065C6.5 21.5175 6.97233 19.1773 7.917 16.986C8.86167 14.795 10.1437 12.889 11.763 11.268C13.3823 9.647 15.2867 8.36383 17.476 7.4185C19.665 6.47283 22.0042 6 24.4935 6C26.9825 6 29.3227 6.47233 31.514 7.417C33.705 8.36167 35.611 9.64367 37.232 11.263C38.853 12.8823 40.1362 14.7867 41.0815 16.976C42.0272 19.165 42.5 21.5042 42.5 23.9935C42.5 26.4825 42.0277 28.8227 41.083 31.014C40.1383 33.205 38.8563 35.111 37.237 36.732C35.6177 38.353 33.7133 39.6362 31.524 40.5815C29.335 41.5272 26.9958 42 24.5065 42ZM24.5 40C28.9667 40 32.75 38.45 35.85 35.35C38.95 32.25 40.5 28.4667 40.5 24C40.5 19.5333 38.95 15.75 35.85 12.65C32.75 9.55 28.9667 8 24.5 8C20.0333 8 16.25 9.55 13.15 12.65C10.05 15.75 8.5 19.5333 8.5 24C8.5 28.4667 10.05 32.25 13.15 35.35C16.25 38.45 20.0333 40 24.5 40Z'
												fill='#1C1B1F'
											/>
										</g>
									</g>
								</svg>
							) : (
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='49'
									height='48'
									viewBox='0 0 49 48'
									fill='none'
								>
									<g id='check_circle'>
										<mask
											id='mask0_154_2929'
											style={{ maskType: 'alpha' }}
											maskUnits='userSpaceOnUse'
											x='0'
											y='0'
											width='49'
											height='48'
										>
											<rect
												id='Bounding box'
												x='0.5'
												width='48'
												height='48'
												fill='#D9D9D9'
											/>
										</mask>
										<g mask='url(#mask0_154_2929)'>
											<path
												id='check_circle_2'
												d='M21.623 31.8155L34.4155 19.023L33 17.6075L21.623 28.9845L15.923 23.2845L14.5075 24.7L21.623 31.8155ZM24.5065 42C22.0175 42 19.6773 41.5277 17.486 40.583C15.295 39.6383 13.389 38.3563 11.768 36.737C10.147 35.1177 8.86383 33.2133 7.9185 31.024C6.97283 28.835 6.5 26.4958 6.5 24.0065C6.5 21.5175 6.97233 19.1773 7.917 16.986C8.86167 14.795 10.1437 12.889 11.763 11.268C13.3823 9.647 15.2867 8.36383 17.476 7.4185C19.665 6.47283 22.0042 6 24.4935 6C26.9825 6 29.3227 6.47233 31.514 7.417C33.705 8.36167 35.611 9.64367 37.232 11.263C38.853 12.8823 40.1362 14.7867 41.0815 16.976C42.0272 19.165 42.5 21.5042 42.5 23.9935C42.5 26.4825 42.0277 28.8227 41.083 31.014C40.1383 33.205 38.8563 35.111 37.237 36.732C35.6177 38.353 33.7133 39.6362 31.524 40.5815C29.335 41.5272 26.9958 42 24.5065 42ZM24.5 40C28.9667 40 32.75 38.45 35.85 35.35C38.95 32.25 40.5 28.4667 40.5 24C40.5 19.5333 38.95 15.75 35.85 12.65C32.75 9.55 28.9667 8 24.5 8C20.0333 8 16.25 9.55 13.15 12.65C10.05 15.75 8.5 19.5333 8.5 24C8.5 28.4667 10.05 32.25 13.15 35.35C16.25 38.45 20.0333 40 24.5 40Z'
												fill='black'
											/>
										</g>
									</g>
								</svg>
							)}
						</div>
						<div className='title-holder'>
							{productAdditionFailed ? (
								'Failed to add item to cart. Please try again.'
							) : (
								<>
									{(response && response.title) ?? 'Product'} has been added to
									your bag
								</>
							)}
						</div>
						{productAdditionFailed ? (
							<Button onClick={() => setProductAdded(false)}>Ok</Button>
						) : (
							<>
								<Button onClick={() => setProductAdded(false)}>
									Continue Shopping
								</Button>
								<Button onClick={() => setProductAdded(false)}>
									See My Bag
								</Button>
							</>
						)}
					</>
				</Modal>
			)}
		</MonacoModalContainer>
	);
};

export default MonacoModal;
